<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  <el-breadcrumb-item :to="{ path: '/daohang'}">成长导航</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						<div class="tiaojian_line" style="margin-top: 0px;">
							<div class="tiaojian_line_left">
								按地区：
							</div>
							<div class="tiaojian_line_right">
								<el-tag type="info" size="small">不限</el-tag>
								<el-dropdown>
									<span class="el-dropdown-link">
										选择省份<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>不限省份</el-dropdown-item>
										<el-dropdown-item>山东</el-dropdown-item>
										<el-dropdown-item>江苏</el-dropdown-item>
										<el-dropdown-item>河南</el-dropdown-item>
										<el-dropdown-item>河北</el-dropdown-item>
										<el-dropdown-item>浙江</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-dropdown>
									<span class="el-dropdown-link">
										选择地市<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>不限</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								
							</div>
						</div>
						<div class="tiaojian_line">
							<div class="tiaojian_line_left">
								按领域：
							</div>
							<div class="tiaojian_line_right">
								<el-tag type="info" size="small">不限</el-tag>
								<el-tag type="info" size="small">新一代信息技术</el-tag>
								<el-tag type="info" size="small">医药</el-tag>
								<el-tag type="info" size="small">食品饮料</el-tag>
								<el-tag type="info" size="small">领域1</el-tag>
								<el-tag type="info" size="small">领域2</el-tag>
								<el-tag type="info" size="small">领域3</el-tag>
							</div>
						</div>
						<div class="tiaojian_line">
							<div class="tiaojian_line_left">
								按时间：
							</div>
							<div class="tiaojian_line_right">
								<el-tag type="info" size="small">不限</el-tag>
								<el-tag type="info" size="small">2019</el-tag>
								<el-tag type="info" size="small">2020</el-tag>
								<el-tag type="info" size="small">2021</el-tag>
								<el-tag type="info" size="small">2022</el-tag>
							</div>
						</div>
						<div class="tiaojian_line">
							<div class="tiaojian_line_left">
								按模块：
							</div>
							<div class="tiaojian_line_right">
								<el-tag type="info" size="small">不限</el-tag>
								<el-tag type="info" size="small">概览</el-tag>
								<el-tag type="info" size="small">风险因素</el-tag>
								<el-tag type="info" size="small">股改过程</el-tag>
								<el-tag type="info" size="small">董高监核</el-tag>
								<el-tag type="info" size="small">诉讼仲裁</el-tag>
								<el-tag type="info" size="small">荣誉资质</el-tag>
							</div>
						</div>
						<div class="tiaojian_line" style="border: 0px;">
							<div class="tiaojian_line_right" style="width: 98%;">
								<el-input
									placeholder="请输入内容"
									prefix-icon="el-icon-search"
									style="width: 40%;"
									>
								</el-input>
								<el-button type="primary" size="medium">搜索</el-button>
							</div>
						</div>
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_region">
								<div class="neirong_line_title">
									<div class="neirong_line_title_icon"></div>陕西华秦科技实业股份有限公司
								</div>
								<div class="neirong_line_summary">
									在广西涠洲岛，海面之下，一场特殊的“造林”行动正在进行。与陆地造林不同，这里种植的是一种海洋生物——珊瑚。科研人员下潜到海底，将拆分好的珊瑚断枝捆绑在礁石上，等待它们的生长。从2013年至今，科研人员在涠洲岛已经建设珊瑚苗床200个，培育珊瑚20万株，修复了涠洲岛8公顷海域的珊瑚礁生态系统。
								</div>
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											<el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button>
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :total="1000">
								</el-pagination>
							</div>
						</div>
						
						
						<div class="neirong_line_right">
							<div class="neirong_right_header">
								<div class="neirong_right_header_title">内容推荐</div>
							</div>
							
							<div class="neirong_ad_title">
								海岸带保护修复工程
							</div>
							<div class="neirong_ad_title">
								区域海洋生态环境
							</div>
							<div class="neirong_ad_title">
								公里的大陆海岸线
							</div>
							<div class="neirong_ad_title">
								记录海洋生物达到2.8万多种
							</div>
							<div class="neirong_ad_title">
								红树林等多个典型海洋生态系统
							</div>
							<div class="neirong_ad_title">
								科研人员在涠洲岛已经建设珊瑚苗床
							</div>
							
							<div class="neirong_ad_image">
								<el-image :src="require('../assets/images/ad1.png')" fit="contain" style="width: 100%;"></el-image>
							</div>
							<div class="neirong_ad_image">
								<el-image :src="require('../assets/images/ad2.png')" fit="contain" style="width: 100%;"></el-image>
							</div>
							
						</div>
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
		},
		data() {
			return {
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
		},
		
		methods: {
			
		}
	}
</script>

<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
</style>